import React, { ComponentProps, FC } from 'react';
import TripGroupInput from './TripGroupInput';
import { useField } from 'formik';
import { Booking } from '../entities/Booking';
import { useTenantContext } from '../context/TenantContext';

const TripGroupInputField: FC<
    React.PropsWithChildren<{
        name: string;
        className?: string;
        onClose?: () => void;
        open?: boolean;
        variant?: ComponentProps<typeof TripGroupInput>['variant'];
        maxOccupancy?: number;
        minOccupancy?: number;
        maxExtraBabyOccupancy?: number;
        surfaceElementVariant?: 'searchbar' | 'input';
        petsAllowed?: number;
        fullHeight?: boolean;
    }>
> = ({
    name,
    className,
    variant = 'dropdown',
    onClose,
    open,
    maxOccupancy,
    minOccupancy,
    maxExtraBabyOccupancy,
    petsAllowed,
    surfaceElementVariant,
    fullHeight,
}) => {
    const { brandConfig } = useTenantContext();

    const [{ value }, , { setValue }] = useField<Booking>(name);
    return (
        <TripGroupInput
            fullHeight={fullHeight}
            className={className}
            loading={false}
            booking={value}
            surfaceElementVariant={surfaceElementVariant}
            setBooking={booking => {
                setValue(booking);
            }}
            maxOccupancy={brandConfig.searchBoxGroup?.maxOccupancy ?? maxOccupancy}
            minOccupancy={brandConfig.searchBoxGroup?.minOccupancy ?? minOccupancy}
            maxExtraBabyOccupancy={maxExtraBabyOccupancy}
            petsAllowed={petsAllowed}
            onToggle={onClose}
            open={open}
            width={1}
            dropDownBorderRadius={0}
            variant={variant}
        />
    );
};

export default TripGroupInputField;
